<!-- No extra whitespace / linebreaks, pre is literal -->
@if (!virtualScroll) {
    @if (code) {
        <pre
            class="code"
            #codeToHighlight
        ><code [ngClass]="'language-' + language">{{code}}</code></pre>
    }
} @else {
    <pre class="code"><code [ngClass]="'language-' + language">@if (codeLines) {
      <cdk-virtual-scroll-viewport [ngStyle]="{'height': virtualScroll + 'px'}" [itemSize]="19"><ng-container *cdkVirtualFor="let codeLine of codeLines"><span style="all:unset;" [innerHTML]="codeLine | safeHtml"></span></ng-container></cdk-virtual-scroll-viewport>
    }</code></pre>
}
